import { Button, Layout, Space, theme, Typography } from "antd";
import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import CustomForm from "../../../shared/components/CustomForm";
import { IoAddSharp } from "react-icons/io5";
import { Link } from "react-router-dom";
import routes from "../../../engine/routes";
import { getInstitutions } from "../Slices/Institutions.slice";
import CustomTable from "../../../shared/components/CustomTable";
import {
  columnsInstitutionsList,
  inputsInstitutionsList,
} from "./InstitutionsListForms";
import { AlignCenterEnd } from "../../../shared/components/AlignCenterEnd/AlignCenterEnd";
import { objectToUrlParams } from "../../../utils/helpersFunction";
import { InstitutionsExportFile } from "./InstitutionsExportFile";

const { Content, Sider, Header, Footer } = Layout;

export function InstitutionsList(props) {
  const { institutions, loading } = useSelector(state => state.institutions);
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");

  // const context = useContext(AppContext);
  const {
    token: { colorBgLyout },
  } = theme.useToken();

  const dispatchActionInstitutions = search => {
    dispatch(getInstitutions(search));
  };

  useEffect(() => {
    const search = objectToUrlParams({});
    dispatchActionInstitutions(search);
  }, []);

  const onValuesChange = (changedValues, allValues) => {
    Object.keys(changedValues).map(changed => {
      switch (changed) {
        case "search":
          setSearch(changedValues[changed]);
          break;
        case "principal":
          const search = objectToUrlParams(allValues);
          dispatchActionInstitutions(search);
          break;
      }
    });
  };

  const searchFilterData = () =>
    institutions.filter(institution => {
      const {
        name = "",
        interventionLocation = "",
        tags = [],
        type = "",
        mainType = "",
        secondName = "",
      } = institution;
      const searchLowerCase = search.toLowerCase();

      let stringTags = "";

      if (tags !== null) {
        stringTags = tags?.map(e => e.label + "")?.join(" ");
      }

      const hasSearchMatch = [
        name,
        type,
        secondName === null ? "" : secondName,
        stringTags,
        mainType,
        interventionLocation,
      ]
        .filter(e => e !== null || e !== undefined)
        .some(field => field.toLowerCase().includes(searchLowerCase));

      return search.length === 0 || hasSearchMatch;
    });

  let copyInstitutions = searchFilterData();

  return (
    <Content>
      <Space
        style={{
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography.Title level={2} className={""}>
          Institutions
        </Typography.Title>
        <Space>
          <InstitutionsExportFile institutions={institutions} />
          <Link to={routes.institutions().new.path}>
            <Button
              size={"large"}
              type={"primary"}
              style={{ justifySelf: "flex-start", display: "flex" }}
              icon={<IoAddSharp style={{ marginTop: "0px" }} size={25} />}
            >
              {routes.institutions().new.title}
            </Button>
          </Link>
        </Space>
      </Space>

      <AlignCenterEnd>
        <CustomForm
          style={{
            flex: 1,
            maxWidth: 1200,
            paddingRight: 20,
          }}
          dataSource={inputsInstitutionsList}
          labelCol={24}
          wrapperCol={24}
          onValuesChange={onValuesChange}
        />
      </AlignCenterEnd>
      <CustomTable
        loading={loading}
        smTitle={item => {
          return (
            <div className={"alignHeaderPage"}>
              <h2 className={"noMargin"}>{item.name}</h2>
            </div>
          );
        }}
        onRowLink={record => routes.institutions(record._id).detail.path}
        hasPagination={true}
        dataSource={copyInstitutions}
        columns={columnsInstitutionsList}
        rowKey="_id"
      />
    </Content>
  );
}
